import { Link } from "react-router-dom";
import { Trash2, Loader2, CalendarClock, MapPin, Clock3 } from "lucide-react";
import { CHANNELS, LANGUAGES, capitalize, daysLeft, CopyButton } from "./shared";

function BookingInfo({ booking, number }) {
  if (!number) return null;
  if (!booking)
    return <div className="text-xs text-zinc-500 mt-3" data-testid="translator-booking-missing">Reserva {number} no encontrada en el sistema.</div>;
  return (
    <Link to={`/services/${booking.id}`} data-testid="translator-booking-link" className="block mt-3 border border-black p-3 hover:bg-zinc-50 transition-colors">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500">Reserva vinculada</div>
      <div className="font-display font-bold">{booking.booking_number} · <span className="text-[#E63946]">{booking.status}</span></div>
      <div className="text-xs text-zinc-600 mt-1 flex items-center gap-1"><CalendarClock size={12} /> {booking.pickup_date} {booking.pickup_time} {booking.flight_number ? `· Vuelo ${booking.flight_number}` : ""}</div>
      <div className="text-xs text-zinc-600 flex items-center gap-1 truncate"><MapPin size={12} /> {booking.pickup_location} → {booking.dropoff_location}</div>
    </Link>
  );
}

export function TranslatorClientCard({ session, booking, onChangeLang, onDelete, langBusy }) {
  const ch = CHANNELS[session.channel] || CHANNELS.otro;
  return (
    <div className="border-2 border-black bg-white p-5" data-testid="translator-client-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 flex items-center gap-1.5"><ch.Icon size={12} /> {ch.label}</div>
          <div className="font-display text-2xl font-bold truncate" data-testid="translator-client-name">{session.client_name}</div>
          {session.client_contact && <div className="text-sm text-zinc-600" data-testid="translator-client-contact">{session.client_contact}</div>}
        </div>
        <div className="flex items-center gap-2">
          <div className="bg-black text-white px-3 py-2 text-xs font-bold uppercase tracking-wider" data-testid="translator-client-lang">
            {session.client_lang} · {capitalize(session.client_lang_name)}
          </div>
          <select
            value=""
            disabled={langBusy}
            onChange={(e) => e.target.value && onChangeLang(e.target.value)}
            className="h-9 border border-black text-xs px-2 bg-white"
            data-testid="translator-change-lang"
          >
            <option value="">Cambiar idioma…</option>
            {LANGUAGES.map((l) => <option key={l} value={l}>{l}</option>)}
          </select>
          {langBusy && <Loader2 className="animate-spin" size={16} />}
          <button onClick={onDelete} className="p-2 border border-black hover:bg-[#E63946] hover:text-white transition-colors" data-testid="translator-delete-session" aria-label="Eliminar conversación">
            <Trash2 size={15} />
          </button>
        </div>
      </div>
      <BookingInfo booking={booking} number={session.booking_number} />
      <div className="mt-4 bg-zinc-50 border-l-4 border-[#E63946] p-4" data-testid="translator-greeting">
        <div className="flex items-center justify-between gap-2 mb-2">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500">Saludo traducido</div>
          <CopyButton text={session.greeting_translated} testId="translator-copy-greeting" />
        </div>
        <p className="text-sm font-medium" data-testid="translator-greeting-translated">{session.greeting_translated}</p>
        <p className="text-xs text-zinc-500 mt-2 italic">{session.greeting_es}</p>
      </div>
      <div className="text-[11px] text-zinc-500 mt-3 flex items-center gap-1" data-testid="translator-expiry">
        <Clock3 size={12} /> Esta conversación se borrará automáticamente en {daysLeft(session.expires_at)} días.
      </div>
    </div>
  );
}
